import React, { useState } from "react";
import { Card, Upload, Button, Typography, message } from "antd";
import {
  UploadOutlined,
  FileTextOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import Swal from "sweetalert2";
import api from "../api/api";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const CargaStoragePdfNorma = () => {
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const getFileName = (contentDisposition) => {
    let fileName = "archivo.csv";

    if (!contentDisposition) return fileName;

    const utf8Match = contentDisposition.match(/filename\*\=UTF-8''(.+)/);
    if (utf8Match && utf8Match[1]) {
      return decodeURIComponent(utf8Match[1]);
    }

    const normalMatch = contentDisposition.match(/filename="?(.+?)"?($|;)/);
    if (normalMatch && normalMatch[1]) {
      return normalMatch[1];
    }

    return fileName;
  };

  const beforeUpload = (file) => {
    const isCSV = file.type === "text/csv" || file.name.endsWith(".csv");

    if (!isCSV) {
      message.error("Solo puedes subir archivos CSV");
      return Upload.LIST_IGNORE;
    }

    setFileList([file]);
    return false;
  };

  const handleUpload = async () => {
    if (fileList.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Atención",
        text: "Debes seleccionar un archivo CSV",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", fileList[0]);

    setLoading(true);

    try {
      const response = await api.post("/api/CargaStoragePdfNorma", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "blob",
      });

      const contentDisposition = response.headers["content-disposition"];
      const fileName = getFileName(contentDisposition);

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
      link.remove();

      Swal.fire({
        icon: "success",
        title: "Descarga completada",
        text: "El archivo fue generado y descargado correctamente.",
      });

      setFileList([]);
    } catch (error) {
      if (error.response && error.response.data) {
        const reader = new FileReader();

        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result);

            Swal.fire({
              icon: "error",
              title: "Error en el archivo",
              text:
                errorData.message ||
                "El archivo tiene errores o no cumple con el formato esperado.",
            });
          } catch {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Ocurrió un error al procesar el archivo.",
            });
          }
        };

        reader.readAsText(error.response.data);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo conectar con el servidor.",
        });
      }
    } finally {
      setLoading(false); // 🔥 SOLO se apaga cuando TODO termina
    }
  };

  return (
    <Card
      style={{
        maxWidth: 600,
        margin: "0 auto",
        borderRadius: 12,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >
      <Title level={3}>Carga Ebooks</Title>
      <Text type="secondary">
        Sube un archivo CSV con la información de las normas a cargar
      </Text>

      <div style={{ marginTop: 20 }}>
        <Upload
          beforeUpload={beforeUpload}
          fileList={fileList}
          onRemove={() => setFileList([])}
          maxCount={1}
        >
          <Button icon={<UploadOutlined />}>Seleccionar archivo CSV</Button>
        </Upload>
      </div>

      {fileList.length > 0 && (
        <div style={{ marginTop: 15 }}>
          <Text strong>
            <FileTextOutlined /> Archivo seleccionado:
          </Text>
          <br />
          <Text>{fileList[0].name}</Text>
        </div>
      )}

      <Button
        type="primary"
        onClick={handleUpload}
        loading={loading}
        style={{
          marginTop: 20,
          width: "100%",
          height: 40,
          borderRadius: 8,
        }}
      >
        {loading ? "Procesando y descargando..." : "Subir CSV"}
      </Button>

      <hr />

      <Button
        icon={<ArrowLeftOutlined />}
        size="large"
        block
        style={{ height: 50, borderRadius: 14 }}
        onClick={() => navigate("/dashboard/ebooks")}
      >
        Volver
      </Button>
    </Card>
  );
};

export default CargaStoragePdfNorma;
